import JSZip from 'jszip'
import 'datatables.net-buttons/js/buttons.html5'
import store from '@/store'
import lang from '@/plugins/lang'
import { nowFormat } from '@/helpers/dateHelper'

window.JSZip = JSZip

const colorPrimary = '7D4FC2'

function addEmptyRowsAt(rel, atRow, qntRows) {
    let t = rel.querySelectorAll('row')

    t.forEach(r => {
        let rowNumber = parseInt(r.getAttribute('r'))

        if (rowNumber <= atRow) {
            return
        }

        let newRowNumber = rowNumber + qntRows

        r.setAttribute('r', newRowNumber)

        r.querySelectorAll('c').forEach(c => {
            let colR = c.getAttribute('r')

            c.setAttribute('r', colR.charAt(0) + newRowNumber)
        })
    })
}

function addRow(rel, sheet, rowIdx, data) {
    let row = rel.createElement('row')

    row.setAttribute('r', 2)

    data.forEach(d => {
        let col = rel.createElement('c')
        let is = rel.createElement('is')
        let t = rel.createElement('t')
        let text = rel.createTextNode(d.t)

        col.setAttribute('r', d.c + rowIdx)
        col.setAttribute("t", "inlineStr")
        col.setAttribute("s", d.s || '0')

        t.setAttribute('xml:space', 'preserve')

        t.appendChild(text)
        is.appendChild(t)
        col.appendChild(is)

        row.appendChild(col)
    })

    sheet.appendChild(row)

    return row
}

/**
 * Convert from numeric position to letter for column names in Excel
 * @param  {int} n Column number
 * @return {string} Column letter(s) name
 */
function createCellPos( n ){
	let ordA = 'A'.charCodeAt(0);
	let ordZ = 'Z'.charCodeAt(0);
	let len = ordZ - ordA + 1;
	let s = "";

	while( n >= 0 ) {
		s = String.fromCharCode(n % len + ordA) + s;
		n = Math.floor(n / len) - 1;
	}

	return s;
}

function mergeCells(rel, row, colStart, colspan) {
    let mergeCells = rel.getElementsByTagName( "mergeCells" )[0];

    let mergeCell = rel.createElement('mergeCell')

    mergeCell.setAttribute('ref', colStart+row+':'+ createCellPos(colspan)+row)

    mergeCells.appendChild(mergeCell);

    mergeCells.setAttribute('count', parseFloat(mergeCells.getAttribute('count')) + 1)
};

function addFont(rel, attr) {
    let fonts = rel.getElementsByTagName('fonts')[0]

    let newFont = rel.createElement('font')
    let sz = rel.createElement('sz')
    let name = rel.createElement('name')

    sz.setAttribute('val', attr.fontSize)
    name.setAttribute('val', attr.fontName)

    newFont.appendChild(sz)
    newFont.appendChild(name)

    if (attr.bold) {
        newFont.appendChild(rel.createElement('b'))
    }

    if (attr.rgb) {
        let color = rel.createElement('color')
        color.setAttribute('rgb', attr.rgb)

        newFont.appendChild(color)
    }

    fonts.appendChild(newFont)

    fonts.setAttribute('count', parseFloat(fonts.getAttribute('count')) + 1)

    return newFont
}

function addFill(rel, rgb) {
    let fills = rel.getElementsByTagName('fills')[0]

    let newFill = rel.createElement('fill')

    let patternFill = rel.createElement('patternFill')

    let fgColor = rel.createElement('fgColor')

    patternFill.setAttribute('patternType', 'solid')

    fgColor.setAttribute('rgb', 'FF' + rgb)

    patternFill.appendChild(fgColor)

    newFill.appendChild(patternFill)

    fills.appendChild(newFill)

    fills.setAttribute('count', parseFloat(fills.getAttribute('count')) + 1)
}

function addCellXfs(rel, attr) {
    let xfs = rel.getElementsByTagName('cellXfs')[0]

    let newXf = rel.createElement('xf')

    newXf.setAttribute('numFmtId', attr.numFmtId || 0)
    newXf.setAttribute('fontId', attr.fontId || 0)
    newXf.setAttribute('fillId', attr.fillId || 0)
    newXf.setAttribute('borderId', attr.borderId || 0)
    newXf.setAttribute('applyFont', attr.applyFont || 1)
    newXf.setAttribute('applyFill', attr.applyFill || 1)
    newXf.setAttribute('applyBorder', attr.applyBorder || 1)

    if(attr.align) {
        newXf.setAttribute('applyAlignment', 1)

        let alignment = rel.createElement('alignment')

        alignment.setAttribute('horizontal', attr.align)

        newXf.appendChild(alignment)
    }

    xfs.appendChild(newXf)

    xfs.setAttribute('count', parseFloat(xfs.getAttribute('count')) + 1)
}


$.extend($.fn.dataTable.ext.buttons, {
    customExcel: {
        extend: 'excel',
        activeFilters: () => ({}),

        /**
         * @return {TotalsTable|null}
         */
        totalsTable: () => null,

        customize( xlsx, config, dt ) {
            let rel = xlsx.xl.worksheets['sheet1.xml']
            let style = xlsx.xl['styles.xml']
            let sheet = rel.getElementsByTagName( "sheetData" )[0]
            let data = dt.buttons.exportData( config.exportOptions )

            // Cria uma nova fonte para o Titulo
            addFont(style, {
                fontName: 'Calibri',
                fontSize: '16',
                rgb: 'FFFFFFFF',
                bold: true
            })

            // Cria uma nova fonte para default bold white
            addFont(style, {
                fontName: 'Calibri',
                fontSize: '11',
                rgb: 'FFFFFFFF',
                bold: true
            })

            // Cria um BG roxo
            addFill(style, colorPrimary)

            // Cria um novo estilo com index 68
            addCellXfs(style, { fontId: '5', align: 'center', fillId: '6' })

            let rowTitle = rel.querySelector('row[r="1"]')

            // Edita o estilo do titulo para o novo index criado a cima
            rowTitle.querySelector('c').setAttribute('s', '68')

            // Aumenta a largura da linha
            rowTitle.setAttribute('ht', '17')
            rowTitle.setAttribute('customHeight', '1')

            // Edita o estilo 2 para bg roxo e color white
            let xfDefaultBold = style.querySelectorAll('cellXfs xf')[2]
            xfDefaultBold.setAttribute('fontId','6')
            xfDefaultBold.setAttribute('fillId','6')

            let groupFilters = config.activeFilters()

            let idxRow = 5

            addEmptyRowsAt(rel, 1, idxRow + Object.keys(groupFilters).length)

            addRow(rel, sheet,2, [
                { c: 'A', t: lang.t('created_at') + ': ' + nowFormat() },
            ])

            addRow(rel, sheet, 3, [
                { c: 'A', t: lang.t('user') + ': ' + store().auth.name }
            ])

            addRow(rel, sheet,5, [
                { c: 'A', t: lang.t('filters'), s: '2' },
            ])

            let colLength = data.header.length-1

            mergeCells(rel, 2, 'A', colLength);
            mergeCells(rel, 3, 'A', colLength);
            mergeCells(rel, 5, 'A', colLength);

            Object.values(groupFilters).forEach(item => {
                let text = ''

                item.forEach(filter => {
                    text += `${filter.input}: ${filter.value || lang.t('no_filter')}; `
                })

                idxRow += 1

                addRow(rel, sheet, idxRow, [
                    { c: 'A', t: text},
                ])

                mergeCells( rel, idxRow, 'A', colLength );
            })

            const totaisTable = this.totalsTable()

            if (totaisTable) {
                addEmptyRowsAt(rel, idxRow, totaisTable.body.length + 3 + (totaisTable.footer ? 1 : 0))

                idxRow += 2

                addRow(rel, sheet, idxRow, [
                    { c: 'A', t: lang.t('report:totals'), s: '2' },
                ])

                mergeCells(rel, idxRow, 'A', colLength);

                idxRow += 1

                addRow(rel, sheet, idxRow, totaisTable.header.map((text, idx) => ({ c: createCellPos(idx), t: text, s: '2'})))

                totaisTable.body.forEach(bodyRow => {
                    idxRow += 1

                    addRow(rel, sheet, idxRow, bodyRow.map((text, idx) => ({ c: createCellPos(idx), t: text })))
                })

                if (totaisTable.footer) {
                    idxRow += 1

                    addRow(rel, sheet, idxRow, totaisTable.footer.map((text, idx) => ({ c: createCellPos(idx), t: text, s: '2'})))
                }
            }
        }
    }
})
